export default {
    items: {
        data: []
    },

    list: []
}